import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from 'common/redux/configureStore';
import App from './components/App';
import _debug from 'debug';
import $ from 'jquery';

const debug = _debug('app::zone');

export default function plan(zone) {
  const root = document.getElementById('zone');
  if (root) {
    debug('Rendering zone plan', zone);
    const disabled = !!$('#zone').hasClass('disabled');
    const store = configureStore();
    ReactDOM.render(
      <Provider store={store}>
        <App id={zone} disabled={disabled} />
      </Provider>,
      root
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/index.js